// import React, { useState } from "react";
// import { Link } from "react-router-dom";


// import Visibility from "@mui/icons-material/Visibility";
// import VisibilityOff from "@mui/icons-material/VisibilityOff";
// // import { useNavigate } from "react-router-dom";




// export default function LoginPage() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
// const [showPassword, setShowPassword] = useState(false);

//   // const navigate = useNavigate();


//   const handleLogin = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!email || !password) {
//       setError("Please fill in all fields.");
//       return;
//     }

//     try {
//       setLoading(true);
//       const response = await fetch("https://yovho-back.vercel.app/logIn-user", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, pass:password }),
//       });

//       const data = await response.json();
//       if(!data.Error){
//         console.log("Login Successful:", data);
//         toast.success("Login successful!");
//       }
//       else{
//         alert(data.Error);
//       }
//     } catch (err) {
//       console.error("Login Failed:", err);
//       setError("Login failed. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const styles = {
//     container: {
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       height: "100vh",
//       background: "linear-gradient(to right, #dbeafe, #ddd6fe)",
//       fontFamily: "Arial, sans-serif",
//     },
//     box: {
//       backgroundColor: "white",
//       padding: "30px",
//       borderRadius: "15px",
//       boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
//       width: "100%",
//       maxWidth: "400px",
//     },
//     heading: {
//       fontSize: "24px",
//       fontWeight: "bold",
//       marginBottom: "20px",
//       textAlign: "center",
//       color: "#333",
//     },
//     input: {
//       width: "100%",
//       padding: "10px",
//       margin: "8px 0",
//       borderRadius: "8px",
//       border: "1px solid #ccc",
//       fontSize: "14px",
//     },
//     button: {
//       width: "100%",
//       padding: "10px",
//       backgroundColor: "#3b82f6",
//       color: "white",
//       border: "none",
//       borderRadius: "8px",
//       cursor: "pointer",
//       fontSize: "16px",
//       marginTop: "10px",
//     },
//     buttonDisabled: {
//       backgroundColor: "#93c5fd",
//       cursor: "not-allowed",
//     },
//     linkContainer: {
//       marginTop: "15px",
//       textAlign: "center",
//       fontSize: "14px",
//     },
//     link: {
//       margin: "0 10px",
//       color: "#006ce4",
//       cursor: "pointer",
//       textDecoration: "underline",
//     },
//     errorText: {
//       color: "red",
//       textAlign: "center",
//       marginBottom: "10px",
//     },
//     agreement: {
//       fontSize: "12px",
//       color: "#666",
//       textAlign: "center",
//       marginTop: "10px",
//     },
//     inputWrapper: {
//   position: "relative",
//   width: "100%",
//   marginBottom: "15px",
// },
// eyeIcon: {
//   position: "absolute",
//   right: "10px",
//   top: "50%",
//   transform: "translateY(-50%)",
//   cursor: "pointer",
//   color: "#666",
// },
//   };

//   return (
//     <>
//     <div style={styles.container}>
//       <div style={styles.box}>
//       <div style={{ textAlign: "left", marginBottom: "20px" }}>
//   <h2 style={{ fontSize: "20px", fontWeight: "bold", margin: "0 0 5px", color: "#333" }}>
//     Sign in or create an account
//   </h2>
//   <p style={{ fontSize: "13px", color: "#555", margin: 0,marginTop:"10px" }}>
//     You can sign in using your <strong>Yovho.com</strong> account to access our amazing deals and updates!.
//   </p>
// </div>
//         {/* <div style={styles.heading}>Login</div> */}

//         {error && <div style={styles.errorText}>{error}</div>}

//         <form onSubmit={handleLogin}>
//           <input
//             type="email"
//             placeholder="Email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             style={styles.input}
//           />
//           <div style={styles.inputWrapper}>
//             <input
//               type={showPassword ? "text" : "password"}
//               placeholder="Password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               style={styles.input}
//             />
//             <span onClick={() => setShowPassword((prev) => !prev)} style={styles.eyeIcon}>
//               {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
//             </span>
//           </div>
//           {/* <input
//             type="password"
//             placeholder="Password"
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//             style={styles.input}
//           /> */}
//           <button
//             type="submit"
//             style={{
//               ...styles.button,
//               ...(loading ? styles.buttonDisabled : {}),
//             }}
//             disabled={loading}
//           >
//             {loading ? "Logging in..." : "Login"}
//           </button>
//         </form>

//         <div style={styles.agreement}>
//           By signing in, I agree to Yovho's{" "}
//           <a href="#" style={{ color: "#006ce4", textDecoration: "underline" }}>
//             Terms of Use
//           </a>{" "}
//           and{" "}
//           <a href="#" style={{ color: "#006ce4", textDecoration: "underline" }}>
//             Privacy Policy
//           </a>.
//         </div>

//         <div style={styles.linkContainer}>
//           <Link to="/forget-password"><span style={styles.link}>Forgot Password?</span></Link>
//           <Link to="/sign-up"><span style={styles.link}>Sign Up</span></Link>
//         </div>
//       </div>
//     </div>
//     </>
//   );
// }




















import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("login"); // "login" ya "verify"
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/"); // already logged in → go home
    }
  }, [navigate]);
  // Step 1: Request login code
  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch("https://striking-dedication-production.up.railway.app/api/v1/user/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      if (!data.Error) {
        toast.success("Verification code sent to your email!");
        setStep("verify");
      } else {
        setError(data.Error);
      }
    } catch (err) {
      console.error(err);
      setError("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

// Step 2: Verify code
const handleVerifyCode = async (e) => {
  e.preventDefault();
  setError("");

  if (!code) {
    setError("Please enter the verification code.");
    return;
  }

  console.log("Code & Email:", code, email);

  try {
    setLoading(true);

    const response = await fetch(
      "https://striking-dedication-production.up.railway.app/api/v1/user/auth/verify-login-otp",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email.trim(),
          otp: code.toString().trim(),
        }),
      }
    );

    const data = await response.json();
    console.log("Verify Response:", data);

    if (data.success && data.data?.token) {
      // save token and user
      localStorage.setItem("authToken", data.data.token);
      localStorage.setItem("User Data", JSON.stringify(data.data.user));

      toast.success("Login successful!");
      navigate("/"); // redirect to home
    } else {
      setError(data.message || "Invalid code.");
    }
  } catch (err) {
    console.error("Verification error:", err);
    setError("Verification failed.");
  } finally {
    setLoading(false);
  }
};




  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      background: "linear-gradient(to right, #dbeafe, #ddd6fe)",
      fontFamily: "Arial, sans-serif",
    },
    box: {
      backgroundColor: "white",
      padding: "30px",
      borderRadius: "15px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      width: "100%",
      maxWidth: "400px",
    },
    heading: {
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: "center",
      color: "#333",
    },
    input: {
      width: "100%",
      padding: "10px",
      margin: "8px 0",
      borderRadius: "8px",
      border: "1px solid #ccc",
      fontSize: "14px",
    },
    button: {
      width: "100%",
      padding: "10px",
      backgroundColor: "#3b82f6",
      color: "white",
      border: "none",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "16px",
      marginTop: "10px",
    },
    buttonDisabled: {
      backgroundColor: "#93c5fd",
      cursor: "not-allowed",
    },
    errorText: {
      color: "red",
      textAlign: "center",
      marginBottom: "10px",
    },
    linkContainer: {
      marginTop: "15px",
      textAlign: "center",
      fontSize: "14px",
    },
    link: {
      margin: "0 10px",
      color: "#006ce4",
      cursor: "pointer",
      textDecoration: "underline",
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <h2 style={styles.heading}>
          {step === "login" ? "Sign in with your email" : "Enter verification code"}
        </h2>

        {error && <div style={styles.errorText}>{error}</div>}

        {step === "login" && (
          <form onSubmit={handleEmailLogin}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
            />
            <button
              type="submit"
              style={{ ...styles.button, ...(loading ? styles.buttonDisabled : {}) }}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Code"}
            </button>
          </form>
        )}

        {step === "verify" && (
          <form onSubmit={handleVerifyCode}>
            <input
              type="text"
              placeholder="Enter code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              style={styles.input}
            />
            <button
              type="submit"
              style={{ ...styles.button, ...(loading ? styles.buttonDisabled : {}) }}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify"}
            </button>
          </form>
        )}

        <div style={styles.linkContainer}>
          <Link to="/forget-password">
            <span style={styles.link}>Forgot Password?</span>
          </Link>
          <Link to="/sign-up">
            <span style={styles.link}>Sign Up</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
